import React, { useState } from 'react';
import { 
  User, 
  Heart, 
  Brain, 
  Users, 
  MessageCircle, 
  BookOpen, 
  Award, 
  Stethoscope,
  X,
  Calendar,
  GraduationCap,
  Star
} from 'lucide-react';

const Doctors = () => {
  const [selectedCategory, setSelectedCategory] = useState('adult');
  const [selectedTitle, setSelectedTitle] = useState('Consultant Psychiatrist'); // Default to first adult care title
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  const categories = [
    { id: 'adult', name: 'Adult Care' },
    { id: 'child', name: 'Child Care' }
  ];

  const adultCareTitles = [
    'Consultant Psychiatrist',
    'Clinical Psychologist', 
    'Psychiatric Social Worker',
    'Consultant Psychologist',
    'Social Worker'
  ];

  const childCareTitles = [
    'Occupational Therapist',
    'Speech Language Pathologist',
    'Behaviour Therapist',
    'Special Educator'
  ];

  const doctors = [
    {
      id: 1,
      name: "Dr RAMACHANDRAN KUTTY",
      title: "Consultant Psychiatrist",
      specialty: "psychology",
      experience: "56+ years",
      education: "MBBS DPM MD",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/c79a9f4b-3893-4582-b3e4-a4da5664277b_1767850573519.png",
      expertise: []
    },
    {
      id: 2,
      name: "Dr PRATHEESH PJ",
      title: "Consultant Psychiatrist",
      specialty: "psychiatry",
      experience: "15+ years",
      education: "MD Psychiatry",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/76a76f6d-f759-4144-aa2e-8c306a0be984_1767850588449.png",
      expertise: ["Bipolar Disorder", "Personality Disorders", "Addiction", "Child Mental Health"]
    },
    {
      id: 3,
      name: "Dr ARJUN KARTHA",
      title: "Consultant Psychiatrist",
      specialty: "therapy",
      experience: "10+ years",
      education: "MD Psychiatrist",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/4ba3da3c-e090-4609-bd2d-5fee185a0bac_1773464835510.png",
      expertise: ["Anxiety", "OCD", "Depression", "Bioplar", "Psychosis"]
    },
    {
      id: 4,
      name: "Dr NATASHA ANTO ANNIE",
      title: "Consultant Psychiatrist",
      specialty: "psychiatry",
      experience: "7+ years",
      education: "MD Psychiatry",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/0feddd9b-81b9-435f-a5b1-a7932ac7877a_1767849055440.png",
      expertise: ["Anxiety", "OCD", "Bipolar Disorder", "Depression","Deaddiction","Pyschosis","Schizophrenia","Substance Addiction"]
    },
    {
      id: 5,
      name: "Dr NASEEM VAAKATH",
      title: "Consultant Psychiatrist",
      specialty: "psychiatry",
      experience: "3+ years",
      education: "MD Pyschiatry",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/ebab43f4-b360-44bf-b4e4-6f60d47c614c_1767432265754.png",
      expertise: ["Personality Disorder", "Anxiety", "Addiction", "Mood Disorders","Queer Affirmative","OCD"]
    },
    {
      id: 6,
      name: "Mr MUHAMMED RABEEH H",
      title: "Clinical Psychologist",
      specialty: "psychiatry",
      experience: "10+ years",
      education: "MSC Clinical Psychology, M.Phil Clinical Psychology, RCI Certified",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/9efe3c68-9271-4ade-9fd4-6d691400f142_1767334065651.png",
      expertise: []
    },
    {
      id: 8,
      name: "Ms AARSHA GOPAN S G",
      title: "Clinical Psychologist",
      specialty: "counseling",
      experience: "8+ years",
      education: "MSC Clinical Psychology, M.Phil Clinical Psychology, RCI Certified",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/aa069581-359b-4055-9e60-be08ac8819d9_1767848749538.png",
      expertise: ["Personality Disorder", "Anxiety", "Depression", "Bipolar Disorders","Anger Management","Psychosis","Severe Psychotic Disorders","Self esteem and confidence ","Work related stress management","OCD","Cognitive Behavioral Therapy","Psychodynamic Psychotherapy","Dialectical Behavior Therapy"]
    },
    {
      id: 9,
      name: "Mr AMEER SUHAIL KS",
      title: "Clinical Psychologist",
      specialty: "counseling",
      experience: "1+ years",
      education: "MA Clinical Psychology,MPhil Clinical Psychology, RCI Certified",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/09fcf991-6cbd-4633-adc3-2d53f3351be3_1767432119574.png",
      expertise: ["Personality Disorder", "Anxiety", "Depression", "OCD","Trauma"]
    },
    {
      id: 10,
      name: "Ms FAIZA P",
      title: "Clinical Psychologist",
      specialty: "counseling",
      experience: "0+ years",
      education: "MA Clinical Psychology,MPhil Clinical Psychology, RCI Certified",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/3bf2cf4b-6799-4186-8e99-87902a2fc987_1767334093785.png",
      expertise: ["Anxiety", "Depression", "OCD", "Anger Management","Personality Disorders","Self Esteem and Confidence","Cognitive Behavioral Therapy","Dialectical Behavior Therapy","Psychodynamic Psychotherapy"]
    },
    {
      id: 11,
      name: "Ms KEERTHANA RABIN RAJ",
      title: "Clinical Psychologist",
      specialty: "counseling",
      experience: "0+ years",
      education: "MSc Clinical Psychology,M.Phil Clinical Psychology,RCI Certified",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/8dd571a4-2001-45a6-906d-c65229d355ef_1767848613788.png",
      expertise: ["Personality Disorder", "Anxiety", "Depression", "Self Esteem and Confidence","Trauma"]
    },
    {
      id: 12,
      name: "Ms LAKSHMI CR",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "8+ years",
      education: "MSW (M&P), M.Phil PSW",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/4ac5c3e1-a97f-4613-b9ca-fd513b9d3585_1767334164359.png",
      expertise: ["Personality Disorder", "Family Counseling", "Couple Therapy", "Depression","Anxiety","OCD","Deaddiction","Anxiety Disorders"]
    },
    {
      id: 13,
      name: "Ms ARCHANA N KUMAR",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "7+ years",
      education: "MSW (M&P), M.Phil PSW",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/d6b4e2e6-ef44-4600-afe4-9aadeeb943bd_1767334236950.png",
      expertise: ["Deaddiction", "Anxiety", "Depression", "Couple Therapy","Family Counseling","Women Health"]
    },
    {
      id: 14,
      name: "Mr PIYUSH T JOSE",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "5+ years",
      education: "MSW (M&P), M.Phil PSW",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/d778892c-0228-423d-9676-313ae3887b56_1767334210639.png",
      expertise: ["Family Counseling", "Addiction", "Personality Disorders", "Anxiety","Adult Mental Health","Geriatric Mental Health","Mood Disorders","Emergency Psychitry","Specialized Therapy","Cognitive Behavioral Therapy","Dialectical Behavior Therapy","Psychodynamic Psychotherapy","Psychosomatic Illness"]
    },
    {
      id: 15,
      name: "Ms KAJAL BABU",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "3+ years",
      education: "MSW (M&P), M.Phil PSW",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/de0b4329-89f4-45c4-a338-487adf0042c7_1767335188248.png",
      expertise: ["Depression", "Anxiety", "Family Counseling", "Deaddiction"]
    },
    {
      id: 16,
      name: "Mr SHONE JOSEPH",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSW , PGDMH",
      image: "https://s3.thoughtdiary.ai/mysolace/Solacenew/team/shone.png",
      expertise: ["Gender Identity", "Mental Health"]
    },
    {
      id: 17,
      name: "Ms RESHMAN MARIA REJI",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "0+ years",
      education: "MSW(M&P), M.Phil. PSW",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/1436c05c-192e-4a43-b276-4f9028a262bd_1767848644515.png",
      expertise: ["Anxiety", "Deaddiction", "Depression", "Personality Disorders"]
    },
    {
      id: 18,
      name: "Ms MOHAMED FAWAS KN",
      title: "Psychiatric Social Worker",
      specialty: "counseling",
      experience: "0 years",
      education: "MSW",
      image: "https://s3.thoughtdiary.ai/mysolace/Solacenew/team/fawas.png",
      expertise: ["Anxiety", "Depression"]
    },
    {
      id: 18,
      name: "FR GITSON P VARGHEESE",
      title: "Consultant Psychologist",
      specialty: "counseling",
      experience: "9+ years",
      education: "MSc Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/Solacenew/team/frgitson.png",
      expertise: ["Family Counseling", "Couple Therapy", "Deaddiction", "Personality and Behavioral issues","Emotional and Adjustment Issues","Child Psychiatry","Behavioral Issues","Personality Disorders","Bipolar Disorder"]
    },
    {
      id: 19,
      name: "Ms ALEENA MARY MATHEW",
      title: "Consultant Psychologist",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSc Clinical Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/9f294a13-28a8-4cfe-9385-11f71f64b02b_1767432220430.png",
      expertise: []
    },
    {
      id: 20,
      name: "Mr AKIL ",
      title: "Consultant Psychologist",
      specialty: "counseling",
      experience: "3+ years",
      education: "Msc Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/36a49c48-c7cc-4810-a0df-20df8488b4a5_1767849779266.png",
      expertise: ["Mood Disorders","Deaddiction"]
    },
    {
      id: 21,
      name: "Ms DEVIPRIYA K S",
      title: "Consultant Psychologist",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSc Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/9b340e27-ca82-4bd6-a0ca-b1b1e782647f_1767849803427.png",
      expertise: ["Personality Disorder", "Anxiety", "Deaddiction", "Bipolar Disorder","Depression","Stress Management"]
    },
    {
      id: 23,
      name: "Ms KALYA R KURUP",
      title: "Consultant Psychologist",
      specialty: "counseling",
      experience: "0+ years",
      education: "MSc Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/b4cb84ad-6c9f-4f5a-81e3-eae03d333de8_1767432185192.png",
      expertise: ["Personality Disorder", "Anxiety", "Depression"]
    },
    {
      id: 24,
      name: "Ms SREESHMA M R",
      title: "Social Worker",
      specialty: "counseling",
      experience: "11+ years",
      education: "MSW (M&P)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/e49d3b30-8229-4080-a535-b6ca1d0d95e5_1767848717879.png",
      expertise: ["Deaddiction", "Couple Therapy", "Family Counseling"]
    },
    {
      id: 25,
      name: "Mr ANANDHU MURUKESHAN",
      title: "Social Worker",
      specialty: "counseling",
      experience: "2+ years",
      education: "MSW (M&P)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/f27ed420-f455-48e4-a80b-2278979f0a4e_1767869264602.png",
      expertise: ["Depression", "Anxiety", "Mood Disorders"]
    },
    {
      id: 26,
      name: "Mr VISHNU SOMAN",
      title: "Social Worker",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSW (M&P)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/16c11250-6b3c-49f9-a069-6996d739af16_1767432305292.png",
      expertise: ["Personality Disorder", "Bipolar Disorder", "LGBTQ+"]
    },
    {
      id: 27,
      name: "Mr GURUDEVAN P",
      title: "Social Worker",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSW (M&P)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/2f45cdd7-222d-4499-a422-9babcd0ed3a7_1767849552702.png",
      expertise: ["Personality Disorder", "Child Mental Health", "Addiction", "Mood Disorders","Social Skill"]
    },
    {
      id: 28,
      name: "Ms DONA GEORGE",
      title: "Social Worker",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSW (M&P)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/e51b8d84-d5c3-4aa1-bdd0-b2b5a43e7f26_1767334268521.png",
      expertise: ["Personality Disorder", "Anxiety", "Deaddiction", "Bipolar Disorders","Depression"]
    },
    {
      id: 29,
      name: "Mr ALBIN JAMES",
      title: "Social Worker",
      specialty: "counseling",
      experience: "0+ years",
      education: "MSW (M&P)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/720255bb-26f6-40d4-aa71-adce2ff72984_1767848680777.png",
      expertise: ["Personality Disorder", "Anxiety", "Deaddiction", "Depression"]
    },
    {
      id: 30,
      name: "Ms SHRUTI ELIZABETH JACOB",
      title: "Occupational Therapist",
      specialty: "counseling",
      experience: "2+ years",
      education: "B.O.T, MS OT, AOTA Membership,AIOTA Membership",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/c84f5d81-2b16-459f-9d12-f11f0243bc91_1767849342142.png",
      expertise: []
    },
    {
      id: 31,
      name: "Ms AKHILA PARVEEN P H",
      title: "Occupational Therapist",
      specialty: "counseling",
      experience: "2+ years",
      education: "Bachelors of Occupational Therapy",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/b4d5540e-6de3-452f-9f8b-9a621e38fc8b_1767849415223.png",
      expertise: []
    },
    {
      id: 32,
      name: "Ms ANNA THOMAS",
      title: "Occupational Therapist",
      specialty: "counseling",
      experience: "1+ years",
      education: "Bachelors of Occupational Therapy",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/405174fc-0d46-496c-b987-0cf424ed5264_1773464786079.png",
      expertise: []
    },
    {
      id: 33,
      name: "Ms DEBORAH FULCRUM",
      title: "Occupational Therapist",
      specialty: "counseling",
      experience: "1+ years",
      education: "Bachelors of Occupational Therapy",
      image: "",
      expertise: []
    },
    {
      id: 34,
      name: "Ms MARIA DAVID",
      title: "Occupational Therapist",
      specialty: "counseling",
      experience: "0+ years",
      education: "Bachelors of Occupational Therapy",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/2eb4abf7-c4eb-43cf-a24c-e3c06acfd358_1767848544565.png",
      expertise: []
    },
    {
      id: 36,
      name: "Ms FATHIMA LABEEBA T",
      title: "Speech Language Pathologist",
      specialty: "counseling",
      experience: "4+ years",
      education: "Bachelor of Audiology and Speech Language Pathology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/769e3c26-4fd8-4d55-9785-418028fe1677_1767848911074.png",
      expertise: []
    },
    {
      id: 37,
      name: "Ms ANGEL MARY BABY",
      title: "Speech Language Pathologist",
      specialty: "counseling",
      experience: "2+ years",
      education: "Bachelor of Audiology and Speech Language Pathology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/532dd0e8-4d57-4fc2-a0b4-e54a1ad2ef52_1767849256512.png",
      expertise: []
    },
    {
      id: 38,
      name: "Ms ANNMOL LIJU",
      title: "Speech Language Pathologist",
      specialty: "counseling",
      experience: "1+ years",
      education: "Bachelor of Audiology and Speech Language Pathology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/c280098e-9116-4280-8c36-0b874a230ad6_1767850078465.png",
      expertise: []
    },
    {
      id: 39,
      name: "Ms JEFFI JOHNSON ABRAHAM",
      title: "Speech Language Pathologist",
      specialty: "counseling",
      experience: "0+ years",
      education: "MSc Speech Language Pathology",
      image: "https://s3.thoughtdiary.ai/mysolace/Solacenew/team/jeffi.png",
      expertise: []
    },
    {
      id: 35,
      name: "Ms AYRINE MARTIN PARAKKA",
      title: "Speech Language Pathologist",
      specialty: "counseling",
      experience: "0 years",
      education: "BASLP",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/8ec354d5-446c-43ec-80d0-4479bb72f16f_1767848588336.png",
      expertise: []
    },
    {
      id: 40,
      name: "Ms RUKSANA THASNI K P",
      title: "Behaviour Therapist",
      specialty: "counseling",
      experience: "3+ years",
      education: "MA Psychology, ABA Therapy",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/c0441408-48c0-449e-b408-c2ff19fe7671_1773464754992.png",
      expertise: []
    },
    {
      id: 41,
      name: "Ms VIJISHA V",
      title: "Behaviour Therapist",
      specialty: "counseling",
      experience: "3+ years",
      education: "MSc Applied Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/0647c0bd-0e50-421a-94c6-01a586fd2ac8_1767848963809.png",
      expertise: []
    },
    {
      id: 42,
      name: "Mr SANOOB T",
      title: "Behaviour Therapist",
      specialty: "counseling",
      experience: "2+ years",
      education: "MSc Counseling Psychology, PG Diploma in Counseling Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/29b82359-ddbd-404f-958c-9459f786bde1_1767849212304.png",
      expertise: []
    },
    {
      id: 43,
      name: "Ms AISWARYA S",
      title: "Behaviour Therapist",
      specialty: "counseling",
      experience: "2+ years",
      education: "MSc Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/783a069a-51e3-47c7-9305-3f9f6d1a4cf4_1767849184975.png",
      expertise: []
    },
    {
      id: 44,
      name: "Ms FATHIMATHUL AALIYA",
      title: "Behaviour Therapist",
      specialty: "counseling",
      experience: "1+ years",
      education: "MSc Applied Psychology",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/da126fe0-f220-4677-a185-2b1a489df928_1767849919138.png",
      expertise: []
    },
    {
      id: 45,
      name: "Ms SHIJIMOL MATHAI",
      title: "Special Educator",
      specialty: "counseling",
      experience: "7+ years",
      education: "BSW, Dip. Special Education",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/64ae1d68-b9f7-4682-9568-8876768cfde3_1767848782116.png",
      expertise: []
    },
    {
      id: 46,
      name: "Ms ANAGHA M",
      title: "Special Educator",
      specialty: "counseling",
      experience: "3+ years",
      education: "D.Ed SE(ID)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/6195b593-8b90-46d7-a243-ebd449e053e3_1767849003040.png",
      expertise: []
    },
    {
      id: 47,
      name: "Ms MARY SHINU THOMSON",
      title: "Special Educator",
      specialty: "counseling",
      experience: "1+ years",
      education: "D.Ed SE(ID)",
      image: "https://s3.thoughtdiary.ai/mysolace/assests/profile-photos/d870ba01-6279-4823-b1c8-488cac1027f2_1767850002991.png",
      expertise: []
    },
  ];

  // Get titles based on selected category
  const getTitlesForCategory = () => {
    return selectedCategory === 'adult' ? adultCareTitles : childCareTitles;
  };

  const filteredDoctors = doctors.filter(doctor => {
    const categoryTitles = getTitlesForCategory();
    const matchesCategory = categoryTitles.includes(doctor.title);
    const matchesTitle = doctor.title === selectedTitle;
    return matchesCategory && matchesTitle;
  });

  const getSpecialtyIcon = (specialty) => {
    switch(specialty) {
      case 'psychiatry': return Brain;
      case 'psychology': return User;
      case 'therapy': return Heart;
      case 'counseling': return Heart;
      default: return User;
    }
  };

  return (
   <div className="min-h-screen bg-gray-50">
    {/* Header */}
    {/* Doctors Header */}
    <section className="relative overflow-hidden bg-[#00A785] text-white">
      <div className="absolute -top-24 left-10 h-72 w-72 rounded-full bg-white/10 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-white/10 blur-3xl"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24 text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-white/70 mb-5">
          Solace Neuro
        </p>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight mb-6">
          Our Expert Team
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          Meet our board-certified psychiatrists, psychologists, and therapists 
          dedicated to your mental health and wellness
        </p>
      </div>
    </section>

      {/* Doctors Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Two-Level Filter Tabs */}
          <div className="mb-8 flex justify-center px-2">
            <div className="w-full max-w-4xl">
              {/* Main Category Tabs */}
              <div className="flex gap-2 mb-6 justify-center flex-wrap">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    onClick={() => {
                      setSelectedCategory(category.id);
                      // Set first title of the selected category
                      const firstTitle = category.id === 'adult' ? adultCareTitles[0] : childCareTitles[0];
                      setSelectedTitle(firstTitle);
                    }}
                    className={`px-4 py-2 sm:px-6 sm:py-3 font-medium text-xs sm:text-sm rounded-lg transition-colors ${
                      selectedCategory === category.id
                        ? 'bg-primary-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    {category.name}
                  </button>
                ))}
              </div>

              {/* Desktop Sub-tabs - Single Row */}
              <div className="hidden lg:flex gap-2 border-b border-gray-200 justify-center">
                {getTitlesForCategory().map((title) => (
                  <button
                    key={title}
                    onClick={() => setSelectedTitle(title)}
                    className={`px-4 py-2 font-medium text-sm border-b-2 transition-colors whitespace-nowrap ${
                      selectedTitle === title
                        ? 'text-primary-600 border-primary-600'
                        : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {title}
                  </button>
                ))}
              </div>
              
              {/* Tablet Sub-tabs - Wrapped */}
              <div className="hidden md:flex lg:hidden flex-wrap gap-1 border-b border-gray-200 justify-center">
                {getTitlesForCategory().map((title) => (
                  <button
                    key={title}
                    onClick={() => setSelectedTitle(title)}
                    className={`px-3 py-1.5 font-medium text-xs border-b-2 transition-colors ${
                      selectedTitle === title
                        ? 'text-primary-600 border-primary-600'
                        : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {title}
                  </button>
                ))}
              </div>
              
              {/* Small Tablet/Sub-laptop - Wrapped */}
              <div className="hidden sm:flex md:hidden flex-wrap gap-1 border-b border-gray-200 justify-center">
                {getTitlesForCategory().map((title) => (
                  <button
                    key={title}
                    onClick={() => setSelectedTitle(title)}
                    className={`px-2 py-1.5 font-medium text-xs border-b-2 transition-colors ${
                      selectedTitle === title
                        ? 'text-primary-600 border-primary-600'
                        : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {title}
                  </button>
                ))}
              </div>
              
              {/* Mobile Sub-Title Tabs */}
              <div className="sm:hidden flex flex-wrap gap-1 border-b border-gray-200 justify-center">
                {getTitlesForCategory().map((title) => (
                  <button
                    key={title}
                    onClick={() => setSelectedTitle(title)}
                    className={`px-2 py-2 font-medium text-xs border-b-2 transition-colors whitespace-nowrap ${
                      selectedTitle === title
                        ? 'text-primary-600 border-primary-600'
                        : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {title}
                  </button>
                ))}
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {filteredDoctors.map((doctor) => {
              const SpecialtyIcon = getSpecialtyIcon(doctor.specialty);
              return (
                <div key={doctor.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer" onClick={() => setSelectedDoctor(doctor)}>
                  {/* Doctor Image */}
                  <div className="h-64 sm:h-72 bg-white flex items-center justify-center px-2">
                    <img 
                      src={doctor.image} 
                      alt={doctor.name}
                      className="w-full h-full object-contain"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.parentElement.innerHTML = `
                          <div class="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center">
                            <span class="text-2xl font-bold text-primary">${doctor.name.split(' ').map(n => n[0]).join('')}</span>
                          </div>
                        `;
                      }}
                    />
                  </div>
                  
                  {/* Doctor Content - Simplified */}
                  <div className="p-3 sm:p-4">
                    <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1">{doctor.name}</h3>
                    <p className="text-primary-600 font-medium mb-2 text-xs sm:text-sm">{doctor.title}</p>
                    <div className="flex items-center text-xs text-gray-600 mb-2">
                      <GraduationCap className="w-3 h-3 mr-1 text-gray-400" />
                      {doctor.education}
                    </div>
                    <div className="flex items-center text-xs text-gray-600">
                      <Calendar className="w-3 h-3 mr-1 text-gray-400" />
                      {doctor.experience} experience
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Doctor Details Modal */}
      {selectedDoctor && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setSelectedDoctor(null)}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto relative custom-scrollbar" onClick={(e) => e.stopPropagation()}>
            {/* Close Button - Top Right */}
            <button
              onClick={() => setSelectedDoctor(null)}
              className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full transition-colors z-10"
            >
              <X className="w-6 h-6 text-gray-500" />
            </button>

            {/* Modal Content */}
            <div className="p-4 sm:p-6">
              <div className="grid md:grid-cols-2 gap-6">
                {/* Doctor Image */}
                <div className="md:col-span-1">
                  <img 
                    src={selectedDoctor.image} 
                    alt={selectedDoctor.name}
                    className="w-full h-96 object-contain bg-white rounded-lg"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(selectedDoctor.name)}&background=00A785&color=fff&size=384`;
                    }}
                  />
                </div>

                {/* Doctor Details */}
                <div className="md:col-span-1 space-y-6">
                  {/* Doctor Name and Title */}
                  <div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">{selectedDoctor.name}</h2>
                    <p className="text-lg sm:text-xl text-primary-600 font-medium">{selectedDoctor.title}</p>
                  </div>

                  {/* Education */}
                  <div className="flex items-start space-x-3">
                    <GraduationCap className="w-5 h-5 text-primary-600 mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Education</h3>
                      <p className="text-gray-600 whitespace-pre-line">{selectedDoctor.education.replace(/,/g, '\n')}</p>
                    </div>
                  </div>

                  {/* Experience */}
                  <div className="flex items-start space-x-3">
                    <Calendar className="w-5 h-5 text-primary-600 mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Experience</h3>
                      <p className="text-gray-600">{selectedDoctor.experience}</p>
                    </div>
                  </div>

                  {/* Expertise */}
                  {selectedDoctor.expertise && selectedDoctor.expertise.length > 0 && (
                    <div className="flex items-start space-x-3">
                      <Star className="w-5 h-5 text-primary-600 mt-1 flex-shrink-0" />
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-900 mb-2">Areas of Expertise</h3>
                        <div className="flex flex-wrap gap-2">
                          {selectedDoctor.expertise.map((skill, index) => (
                            <span key={index} className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium">
                              {skill}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Custom Scrollbar Styles */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #00A785;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #00896d;
        }
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: #00A785 #f1f1f1;
        }
      `}</style>
    </div>
  );
};

export default Doctors;
